import { createAsyncThunk } from '@reduxjs/toolkit';
import portalApi from '../../core/api/portal.api';
import {
  LinkParticipantSampleResponse,
  LinkParticipantSampleRequest,
  Participant,
  GetParticipantResponse,
  GraphQlError,
  SampleLink,
} from '../../core/types/common.types';

export const participantThunk = createAsyncThunk<
  Participant,
  string,
  {
    extra: {
      jwt: string;
    };
    rejectValue: GraphQlError[];
  }
>('participant/getParticipant', async (id, thunkApi) => {
  const response: GetParticipantResponse = await portalApi.getParticipant(id);
  const errors = response.errors;
  const participant = response.data?.getParticipantDetails;

  if (errors) {
    return thunkApi.rejectWithValue(errors);
  }

  return participant as Participant;
});

export const linkParticipantAndSampleThunk = createAsyncThunk<
  SampleLink,
  LinkParticipantSampleRequest,
  {
    extra: {
      jwt: string;
    };
    rejectValue: GraphQlError[];
  }
>('participant/linkParticipantAndSample', async ({ participantId, sampleBarcode }, thunkApi) => {
  console.log('linkParticipantAndSample', sampleBarcode, participantId);
  const response: LinkParticipantSampleResponse = await portalApi.linkParticipantSample({
    participantId,
    sampleBarcode,
  });

  console.log('linkParticipantAndSample', response);

  const errors = response.errors;
  const participant = response.data?.linkParticipantSample;

  if (errors) {
    return thunkApi.rejectWithValue(errors);
  }

  return participant as SampleLink;
});
